<template>
  <div class="grid grid-cols-12 gap-2 font-bold">
    <div class="col-span-7 truncate">Item</div>
    <div class="col-span-2 text-center">Quantity</div>
    <div class="col-span-3 text-right">Amount</div>
  </div>
</template>
